import styles from './Error.module.scss';

const Error = ({ text }) => (
  <div className={styles.error}>
    <div className={styles.iconWrapper}>
      <img src="/images/templates/warning-red.svg" alt="(!)" />
    </div>
    <p>{text}</p>
  </div>
);

export default Error;
